<template>
  <!--- 右边快速导航 -->
  <aside class="ys_aside_right">
    <ul>
      <li
        @click="$bus.$emit('registerPopup')" v-if="!sysInfo.sys_id||sysInfo.sys_id==11"
      >
        <img  src="@/static/right_01.png"/>
        注册
      </li>
      <!-- <li
        :class="{ active: hotInto}"
        v-scrollTo="'hot_container'"
        v-if="pathUrl === '/index'"
      >
        渠道热销
      </li> -->
      <li
        :class="{ active: !hotInto && classifyInto }"
        v-scrollTo="'classify_container'"
        v-if="pathUrl === '/index'"
      >
        分类推荐
      </li>
      <li
        @click="navTo('/manager/goodsNew/goodsList','',true)"
      >
        <img  src="@/static/right_02.png"/>
        选品库
      </li>
      <li @click="navTo('/cart')">
        <img  src="@/static/right_03.png"/>
        购物车
      </li>
      <li v-scrollTo>
        <i class="el-icon-arrow-up"></i>
        顶部
      </li>
    </ul>
  </aside>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "ys-aside-right",
  data() {
    return {
      asideList: [],
      hotInto: false,
      classifyInto: false,
    };
  },
  computed: {
    ...mapState(['sysInfo']),
    pathUrl() {
      return this.$route.path;
    },
  },
  mounted() {
    this.$bus.$on("indexObserve", ({ into, type }) => {
      this[type + "Into"] = into;
    });
  },
};
</script>

<style scoped lang="scss">
/* 侧导航 */
.ys_aside_right {
  --media-width: 1720px;

  background-color: #ffffffa3;
  font-size: 14px;
  position: fixed;
  right: -3px;
  bottom: calc(50% - 132px);
  width: 82px;
  text-align: center;
  // padding: 10px 0 20px;
  border-radius: 10px 0 0 10px;
  z-index: 9;
  box-shadow: 0 0 10px 0 #ff244263;
  border: 3px solid var(--theme-color);
  user-select: none;

  ul {
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      cursor: pointer;
      position: relative;
      padding: 12px 0;
      img,i {
        display: block;
        margin: 0 auto;
        // width: 25px;
        // height: 25px;
      }
    }

    li ~ li::before {
      content: "";
      position: absolute;
      top: 0;
      left: calc(50% - 30px);
      width: 60px;
      height: 0px;
      border: 1px solid;
      border-image: linear-gradient(315deg, #ff244200, var(--theme-color), #ff244200) 1 1;
    }

    li:hover,
    li.active {
      color: var(--theme-color);
    }
  }
}

@media (max-width: $mediaWidth) {
  .ys_aside_right {
    --media-width: 998px;
  }
}

@media (max-width: 1720px) {
  // .ys_aside_right {
  //   right: 10px;
  // }
}
</style>
